import { apiClient } from './apiClient'
import { apiClientTeams } from './apiClientTeams'
import { apiClientAddresses } from './apiClientAddresses'
import { apiClientMessages } from './apiClientMessages'
import { apiClientRatings } from './apiClientRatings'

const apiClients = {
	...apiClient,
	...apiClientTeams,
	...apiClientAddresses,
	...apiClientMessages,
	...apiClientRatings,
}

export { apiClients }
